import { Component, Input } from '@angular/core';

/**
 * Clean KPI tile — big tabular number, small uppercase label, optional sub.
 * Use the `tone` input to color the value: 'accent' | 'settled' | 'partial' | 'failed'.
 */
@Component({
	selector: 'app-kpi-tile',
	templateUrl: './kpi-tile.component.html',
	styleUrls: ['./kpi-tile.component.scss']
})
export class KpiTileComponent {
	@Input() label: string = '';
	@Input() value: string | number = '';
	@Input() sub: string | null = null;
	@Input() tone: 'default' | 'accent' | 'settled' | 'partial' | 'failed' = 'default';

	get toneClass(): string {
		switch (this.tone) {
		case 'accent': return 'is-accent';
		case 'settled': return 'is-settled';
		case 'partial': return 'is-partial';
		case 'failed': return 'is-failed';
		default: return '';
		}
	}
}
